import axios from 'axios'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'
import { createJsonData } from 'helpers/generalHelpers'

// #region WEBHOOK
const workspace = getCurrentWorkspace()

export const webhook = {
  create: (formSlug, formObj) =>
    axios.post(
      `${APIURL}/v4/forms/${formSlug}/webhooks/`,
      createJsonData(formObj),
      config({ contentType: HTTP.ContentTypes.JSON, workspace })
    ),

  getAll: (formSlug) =>
    axios.get(
      `${APIURL}/v4/forms/${formSlug}/webhooks/`,
      config({ workspace })
    ),

  delete: (formSlug, webhookSlug) =>
    axios.delete(
      `${APIURL}/v4/forms/${formSlug}/webhooks/${webhookSlug}/`,
      config({ workspace })
    ),
}

// #endregion WEBHOOK
